export enum StorageError {
	CatalogExists = "catalog-exists",
}
